import './styles/index.scss';
import { ModulesProcessor } from '@g.frame/core';
import { LoadersModule } from '@g.frame/common.loaders';
import { DesktopModule } from '@g.frame/desktop';
import { InputModule } from '@g.frame/input';
import { Vector3 } from 'three';
import { Main } from './ts/main';
import { TextComponentModule } from '@g.frame/components.text';
import { XRManagerModule } from '@g.frame/common.xr_manager';
import { PickingControllerModule } from '@g.frame/common.picking_controller';
import { OculusPickButton, OculusQuestModule } from '@g.frame/oculus.quest';
import { UIModule } from './ts/g.frame.modules/uiModule/src/UIModule';
import { InstrumentsPackModule } from './ts/g.frame.modules/instruments_pack/src/InstrumentsPackModule';
import { QuestHandViewModule } from './ts/g.frame.modules/hands_view/src/QuestHandViewModule';
class App {
    constructor() {
        this.framework = new ModulesProcessor({
            modules: [
                new LoadersModule(),
                new QuestHandViewModule(),
                new InstrumentsPackModule(),
                new DesktopModule({
                    mousePickingController: {
                        minPickingDistance: .2,
                        maxPickingDistance: 20,
                        controllersQuantity: 1
                    }
                }),
                new OculusQuestModule({
                    oculusQuestPickingController: {
                        minPickingDistance: .2,
                        maxPickingDistance: 20,
                        controllersQuantity: 2,
                        buttonToPick: OculusPickButton.ANY
                    }
                }),
                new InputModule(),
                new PickingControllerModule(),
                new TextComponentModule(),
                new XRManagerModule(),
                new UIModule(),
            ],
            viewerConfig: {
                renderer: {
                    antialias: true,
                    alpha: true,
                    preserveDrawingBuffer: false,
                    sortObjects: false,
                    shadowMapEnabled: true,
                    // clearColor: 0xefeef3,
                    clearColor: 0x444444,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    autoResize: true,
                    containerID: 'app',
                    onWindowResize: true,
                },
                scene: {
                    overrideMaterial: null
                },
                camera: {
                    fov: 45,
                    near: 0.05,
                    far: 1000,
                    position: new Vector3(0, 1.7, .2),
                    target: new Vector3(0, 1.7, .2),
                }
            },
            bootstrap: this.bootstrap = new Main()
        });
    }
}
const app = new App();
export { app };
